import { IApplicationQuestion } from "./application-question.model";

export interface IQuestion {
  previous: number;
  current: number;
  next: number;
  currentQuestion: IApplicationQuestion | null;
  numberOfQuestions: number;
}
export const initialStateQuestions: IQuestion = {
  previous: 0,
  current: 0,
  next: 0,
  currentQuestion: null,
  numberOfQuestions: 0,
};
